const materials = [
  '恭喜您已成功获得网易有道词典笔免费赠送申请名额。请在2021年5月25日-5月28日填写下方相关信息和提交相关资质材料。材料审核通过后，可成功获得有道词典笔一支。审核结果将通过短信发送，请注意查收。',
  '我们将在6月为您发货，请留意短信通知，感谢您的耐心等待！',
  '*仅限于收到成功获得申请名额短信的用户提交，手机号作为判别依据。',
  '* 请如实填写个人信息，确保信息的真实性，请勿重复提交申请。',
  '* 以下信息仅用于本次活动，网易有道将严格保密您的个人信息',
  '* 如有疑问请联系客服咨询，客服电话：4008004163。',
]

export default materials
